import type { LabelKey } from './labelKey';
import type { InlineEntry, InlineOverrides } from './types';

export const PROFILE_STATUS_FIELD_KEY = '__status__';
export const NAME_GROUP_KEY = '__name__';
export const EMAILS_FIELD_NAME = 'emails';

export const inlineField = <P, K extends string>(
	key: K,
	read: (profile: P) => unknown,
	overrides: InlineOverrides = {}
): InlineEntry<P, K> => ({ type: 'field', key, read, ...overrides });

export const inlineName = <P, K extends string>(
	keys: readonly K[]
): InlineEntry<P, K> => ({ type: 'name', keys });

export const inlineStatus = <P, K extends string>(): InlineEntry<P, K> => ({
	type: 'status'
});

export const inlineEmails = <P, K extends string>(
	label: LabelKey
): InlineEntry<P, K> => ({ type: 'emails', label });

export const inlineCollection = <P, K extends string>(
	key: K,
	count: (profile: P) => number,
	label?: LabelKey
): InlineEntry<P, K> => ({ type: 'collection', key, count, label });
